<div fxLayout="row" fxLayoutAlign="start" fxLayoutGap="3%">
  <ng-content></ng-content>
</div>
